import { render } from "./saved-item-information.vue?vue&type=template&id=38972152&scoped=true"
import script from "./saved-item-information.vue?vue&type=script&lang=js"
export * from "./saved-item-information.vue?vue&type=script&lang=js"

import "./saved-item-information.vue?vue&type=style&index=0&id=38972152&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38972152"]])

export default __exports__